<!-- 主页面 -->
<template>
  <div class="main">
    <TxAccount @refreshTaskList="refreshTaskList" />
    <div class="main-show f-row f-zhu-center" @click="handle_play_video">
      <Image src="logo_2" />
      <TxImage
        src="play_video"
        :size="{ width: 50, height: 50 }"
        class="play-video heart"
      />
    </div>
    <div id="choujiang" class="yuyue-text f-colum f-fu-center">
      <TxImage src="biaoti0" />
      <div class="f-row f-zhu-center">
        <Image src="xian" />
        <span class="shaoxia-jihe">已有 {{ yuyue }} 位少侠集合</span>
        <Image src="xian" class="r-180" />
      </div>
    </div>
    <div class="main-reward f-colum f-fu-center" style="position: relative">
      <ItemContainer src="jiangli" @click="showJiangchi" />
      <ItemContainer
        src="db"
        class="m-auto f-row f-zhu-center f-fu-center chakan"
      >
        <Image src="wenhao" />
        <span class="look_reward" @click="showJiangchi">查看奖池</span>
      </ItemContainer>
      <danmu-section />
    </div>
    <TxRule />
    <RewardBtn />
    <VideoEffect
      ref="video_effect_ref"
      @ended="handle_show_reward"
      video="https://g20.gsf.netease.com/2025092902/2025092802/1.mp4"
    />
    <VideoEffect
      ref="video_effect_ref_2"
      video="https://g20.gsf.netease.com/20251017/20251017/2.mp4"
      @ended="handle_show_reward"
      :item_id="show_id"
    />
    <TxDialog v-model="dialog_state.hongbao">
      <h1>红包页面</h1>
    </TxDialog>
    <TxDialog v-model="dialog_state.jiangchi">
      <TxContainer class="main-fenxiang" src="db_9-2">
        <span class="m-20 t-s-30 t-center">奖池</span>
        <div class="p-r f-center">
          <nut-swiper
            class="swiper-container"
            style="height: 280px; width: 398px"
            ref="swiperRef"
            duration="0"
            :touchable="false"
          >
            <nut-swiper-item
              v-for="(item, index) in show_jiangchi"
              :key="index"
              class="f-center"
            >
              <TxImage :src="activity_config.item_data[item].icon_3" />
              <ItemContainer
                src="hengdi1"
                class="jiangchi-tips t-s-20 f-center p-r"
              >
                <span class="t-s-40 swiper-item-name">{{
                  activity_config.item_data[item].name
                }}</span>
                {{ activity_config.item_data[item].desc_2 }}
              </ItemContainer>
            </nut-swiper-item>
          </nut-swiper>
          <div class="reward-swiper-left f-center" @click="handlePrev">
            <TxButton src="zuo" name="奖池左滑" />
          </div>
          <div @click="handleNext" class="reward-swiper-right f-center">
            <TxButton src="you" name="奖池右滑" />
          </div>
        </div>
        <div class="all-reward">所有奖励</div>
        <div class="main-jiangchi f-row f-wrap y-overflow">
          <template v-for="c in activity_config.awrad_data">
            <ItemContainer
              v-if="activity_config.item_data[c].is_gold == 1"
              src="jin"
              class="m-5 f-center"
              @click="handle_show_tips(c)"
              :size="{ width: 90, height: 90 }"
            >
              <TxImage
                :src="activity_config.item_data[c].icon"
                :size="{ width: 75, height: 75 }"
              />
            </ItemContainer>
            <ItemContainer
              v-else
              src="dikuang"
              class="m-5 f-center"
              @click="handle_show_tips(c)"
              :size="{ width: 90, height: 90 }"
            >
              <TxImage
                :src="activity_config.item_data[c].icon"
                :size="{ width: 75, height: 75 }"
              />
            </ItemContainer>
          </template>
        </div>
      </TxContainer>
    </TxDialog>
    <TxDialog v-model="dialog_state.reward" :close-on-click-overlay="false">
      <TxContainer class="main-fenxiang f-colum f-fu-center" src="db_9">
        <div class="m-t-10 t-s-30">恭喜获得</div>
        <div
          class="main-fenxiang-container-2 f-colum f-zhu-center f-fu-center"
          @click="handle_show_tips(chou.item_id)"
        >
          <TxImage
            :src="activity_config.item_data[chou.item_id].icon_3"
            v-if="is_high"
          />
          <ItemContainer
            v-else
            src="dikuang"
            class="main-reward-item f-colum f-zhu-center f-fu-center"
          >
            <Image
              :src="activity_config.item_data[chou.item_id].icon"
              alt=""
              :size="{ width: 100, height: 100 }"
            />
            <ItemContainer
              class="main-reward-item-count"
              v-if="chou.bonus_type == 1"
              src="db_7"
              >x2</ItemContainer
            >
          </ItemContainer>
          <span class="t-black m-5" v-if="!is_high">{{
            activity_config.item_data[chou.item_id].name
          }}</span>
          <span v-else class="t-black m-5 hight-reward-name">{{
            activity_config.item_data[chou.item_id].name
          }}</span>
          <ItemContainer
            class="main-reward-together m-20 f-colum f-fu-center"
            src="db_8"
            v-if="chou.bonus_type == 1"
          >
            <span>触发同享,你有我有</span>
            <p class="p-5">
              欧气爆棚，福气成双！触发同享奖励，你一份，TA一份，成功分享后双方均可获得奖励
            </p>
          </ItemContainer>
          <ItemContainer
            class="f-row f-zhu-center t-white countdown"
            src="db_6"
            v-if="chou.bonus_type == 1"
          >
            <nut-countdown
              class="countdown"
              :end-time="chou.expired_at * 1000"
              format="mm:ss"
            ></nut-countdown
            >后过期
          </ItemContainer>
        </div>
        <TxButton
          v-if="is_high"
          class="dialog-btn t-shadow t-btn"
          src="anniu_2"
          name="分享"
          @click="handle_share_reward"
        >
          分享获得</TxButton
        >
        <TxButton
          v-else-if="chou.bonus_type == 0"
          class="dialog-btn t-shadow t-btn"
          src="anniu_2"
          name="抽奖领取按钮"
          @click="dialog_state.reward = false"
          >收下</TxButton
        >

        <TxButton
          v-else
          class="dialog-btn t-shadow t-btn"
          src="anniu_2"
          name="同享赠送"
          @click="handle_share"
          >赠送</TxButton
        >
        <div class="f-center dialog-close">
          <TxButton src="gb" @click="dialog_state.reward = false"></TxButton>
        </div>
      </TxContainer>
    </TxDialog>

    <TxDialog v-model="together_id">
      <TxContainer
        class="main-fenxiang f-zhu-center f-fu-center f-colum"
        src="db_9"
      >
        <h2 class="t-white t-center tongxiang-title t-s-30">恭喜获得</h2>
        <template v-if="bonus_data">
          <div class="tongxiang-container f-center">
            <ItemContainer src="dikuang" class="f-center">
              <TxImage
                :src="activity_config.item_data[bonus_data.item_id].icon"
                :size="{ width: 120, height: 120 }"
              />
            </ItemContainer>
            <span class="t-black">{{
              activity_config.item_data[bonus_data.item_id].name
            }}</span>
          </div>
          <ItemContainer src="wenzid" class="t-white t-center">
            <template v-if="bonus_data.status == 0">
              <span class="t-2">{{ bonus_data.share_account }}</span
              >分享给您
            </template>
            <template v-else-if="bonus_data.status == 1">
              <span class="t-2">同享奖励已被领取</span>
            </template>
            <template v-else-if="bonus_data.status == 2">
              <span class="t-2">同享奖励已过期</span>
            </template>
          </ItemContainer>
          <TxButton
            v-if="bonus_data.status == 0"
            src="anniu_2"
            class="t-btn"
            name="领取同享奖励"
            @click="handle_get_bonus"
          >
            领取奖励
          </TxButton>
        </template>
      </TxContainer>
    </TxDialog>

    <!-- tips展示 -->
    <TxDialog v-model="is_tips">
      <div class="tips-container t-white f-colum f-fu-center">
        <div class="tips-header f-row f-fu-center p-l-20">
          <ItemContainer
            v-if="computed_tips.is_gold == 1"
            class="m-r-10 f-center"
            src="jin"
            :size="{ width: 80, height: 80 }"
          >
            <TxImage
              :src="computed_tips.icon"
              :size="{ width: 70, height: 70 }"
            />
          </ItemContainer>
          <ItemContainer
            v-else
            class="m-r-10 f-center"
            src="jpdi"
            :size="{ width: 80, height: 80 }"
          >
            <TxImage
              :src="computed_tips.icon"
              :size="{ width: 70, height: 70 }"
            />
          </ItemContainer>
          <span class="tips-name">{{ computed_tips.name }}</span>
        </div>
        <ItemContainer src="xian"></ItemContainer>
        <div class="tips-content">
          <template v-if="tips_info">
            <div v-for="cell in tips_info" class="wuqiTips-item">
              <template v-for="item in cell">
                <template v-if="item.divType == ''">
                  <div
                    :class="item.data.class"
                    :style="methodsStyle(item.data.style)"
                  >
                    {{ item.text }}
                  </div>
                </template>
              </template>
            </div>
          </template>
          <template v-else>
            {{ computed_tips.desc }}
          </template>
        </div>
      </div>
    </TxDialog>

    <!-- 具体逻辑 -->
    <div class="f-colum m-t-20 m-b-20 main-choujiang">
      <div class="f-row f-zhu-center p-r">
        <template
          v-if="
            Object.keys(init_data).length > 0 && init_data.act_data.is_appointed
          "
        >
          <ItemContainer
            src="qipao"
            v-if="!computed_lotter_items && computed_task != 2"
            class="qipao t-center p-l-40"
          >
            <span class="t-white t-s-16" v-if="computed_task == 0"
              >抽奖次数+2</span
            >
            <span class="t-white t-s-16" v-else-if="computed_task == 1"
              >抽奖次数+1</span
            >
          </ItemContainer>
          <TxButton
            class="m-b-10 t-btn"
            v-if="computed_lotter_items"
            src="anniu_2"
            name="开抽"
            @click="handle_chou"
            >立即抽取
          </TxButton>
          <TxButton
            class="m-b-10 t-btn"
            v-else-if="computed_task == 0"
            src="anniu_2"
            name="分享"
            @click="showShareGuideHandle('first')"
            >分享
          </TxButton>
          <TxButton
            class="m-b-10 t-btn"
            v-else-if="computed_task == 1"
            src="anniu_2"
            name="邀请预约"
            @click="handle_invite"
            >邀请预约</TxButton
          >
          <TxButton
            class="m-b-10 t-btn"
            v-else-if="computed_task == 2"
            src="anniu_2"
            name="次数不足"
            @click="handle_tips"
          >
            抽奖</TxButton
          >
        </template>
        <template v-else>
          <ItemContainer src="qipao" class="qipao t-center p-l-40">
            <span class="t-white t-s-16">即得现金，最高888元</span>
          </ItemContainer>
          <TxButton
            class="m-b-10 t-btn"
            src="anniu_2"
            name="预约"
            @click="handle_yuyue"
            >立即预约</TxButton
          >
        </template>
      </div>
      <div class="f-row f-zhu-center">
        <template v-if="computed_lotter_items">
          <span class="main-chou">
            剩余抽奖次数:
            <!-- <span class="t-2">{{ computed_lotter_items }} 次</span> -->
            {{ computed_lotter_items }} 次
          </span>
        </template>
        <template v-else>
          <span class="main-chou">真金白银直接送，更有iPhone17 Pro待君取</span>
        </template>
      </div>
    </div>

    <div class="task p-20">
      <div class="task-header m-t-20 f-row f-zhu-center">
        <Image src="xian" />
        <TxImage src="2" class="xian-margin" />
        <Image src="xian" class="r-180" />
      </div>
      <div class="task-list f-row f-zhu-center">
        <div
          class="f-colum f-fu-center m-lr-30"
          v-show="
            task_list_status.length == 0 || task_list_status[0].status == 0
          "
        >
          <ItemContainer
            src="fenxiang"
            class="f-colum f-zhu-end f-fu-center p-b-10"
          >
            首次分享
          </ItemContainer>
          <Image src="liangci" />
          <div class="share-link" @click="showShareGuideHandle('first')">
            分享>
          </div>
        </div>
        <div class="f-colum f-fu-center m-lr-30">
          <ItemContainer
            src="yaoqing"
            class="f-colum f-zhu-end f-fu-center p-b-10"
          >
            邀请一人预约<br />
            (当前:{{
              task_list_status.length ? task_list_status[1].progress : 0
            }}/100)
          </ItemContainer>
          <Image src="yici" />
          <div class="share-link" @click="handle_invite">邀请></div>
        </div>
        <div
          class="f-colum f-fu-center m-lr-30"
          v-show="
            task_list_status.length == 0 || task_list_status[2].status == 0
          "
        >
          <ItemContainer
            src="zudui"
            class="f-colum f-zhu-end f-fu-center p-b-10"
          >
            创建或加入团队 <br />
            (团队人数>=2)
          </ItemContainer>
          <Image src="yici" />
          <div class="share-link" @click="handle_create_team">组队></div>
        </div>
      </div>
      <Image class="m-auto f-row f-zhu-center" src="jiantou" />
    </div>

    <TxDialog v-model="item_id">
      <TxContainer
        class="main-fenxiang f-zhu-center f-fu-center f-colum"
        src="db_9"
      >
        <h2 class="t-white t-center tongxiang-title t-s-30">奖励</h2>
        <template v-if="dajiang_data">
          <div class="tongxiang-container f-center">
            <ItemContainer src="dikuang" class="f-center">
              <TxImage
                :src="activity_config.item_data[dajiang_data.item_id].icon"
                :size="{ width: 120, height: 120 }"
              />
            </ItemContainer>
            <span class="t-black">{{
              activity_config.item_data[dajiang_data.item_id].name
            }}</span>
          </div>
          <ItemContainer src="wenzid" class="t-white t-center">
            <span class="t-2">{{ dajiang_data.share_account }}</span
            >抽到
          </ItemContainer>
        </template>
      </TxContainer>
    </TxDialog>
    <TxDialog v-model="is_video">
      <video
        autoplay
        width="100%"
        ref="videoRef"
        controls
        src="https://tx.fp.ps.netease.com/file/68f759365b1167d462e5af31F4yKpyvS06"
        playsinline
        webkit-playsinline
        @ended="onVideoEnded"
      ></video>
    </TxDialog>
    <TxButton
      class="group-btn t-btn"
      src="jinqun"
      name="进群"
      @click="showGroupGuideModal"
    ></TxButton>
    <team-section
      id="baotuan"
      @inviteMember="showShareGuideHandle('invite')"
      @showAwardTip="handle_show_tips"
    />
    <new-section
      id="banben"
      @showAwardTip="handle_show_tips"
      @click="handle_yuyue"
    />
    <popup-join-team />
    <popup-hongbao />
    <popup-group-guide />
    <popup-share-guide />
    <popup-commom-tip />
    <popup-danmu-list />
  </div>
</template>

<script setup>
import {
  defineAsyncComponent,
  inject,
  onMounted,
  shallowReactive,
  ref,
  shallowRef,
} from 'vue';
const {
  init_data,
  set_table_data,
  update_usable_lottery_times,
  together_id,
  login_status,
  error_codemsg,
  set_together_id,
  item_id,
} = inject('GlobalData');
const { set_activity_config, activity_config, channel, share_id } =
  inject('GlobalStore');
const GlobalReporter = inject('GlobalReporter');
import eventEmitter from '@utils/event';
import useWeChatEnv from '../plugins/vue/useWeChatOrMiniProgram';
import {
  get_get_task_list,
  get_do_share,
  get_table_data,
  post_draw_lottery,
  get_bonus_share_data,
  post_share_bonus,
  get_appoint_data,
  appoint,
  get_redpacket_info,
} from '@utils/api';
import VideoEffect from '../components/videoEffect.vue';
import RewardBtn from './rewardBtn.vue';
import { choujiangShareConfig, inviteShareConfig } from './constant';
import PopupJoinTeam from './popups/popup-join-team.vue';
import PopupHongbao from './popups/popup-hongbao.vue'; // 红包弹窗
import getRandomInt from '../utils/getRandomInt';
import encodeText from '../utils/encodText';
import config from '@img/config.json';

const TeamSection = defineAsyncComponent({
  loader: () => import('./components/team_section.vue'), //组队部分
});

const PopupCommomTip = defineAsyncComponent({
  loader: () => import('./popups/popup-commom-tip.vue'), // 通用提示弹窗
});

const PopupShareGuide = defineAsyncComponent({
  loader: () => import('./popups/popup-share-guide.vue'), // 分享指引
});

const PopupDanmuList = defineAsyncComponent({
  loader: () => import('./popups/popup-danmu-list.vue'), // 弹幕列表
});

const PopupGroupGuide = defineAsyncComponent({
  loader: () => import('./popups/popup-group-guide.vue'), // 入群指引
});

const NewSection = defineAsyncComponent({
  loader: () => import('./components/news_section.vue'), //资讯部分
});

const DanmuSection = defineAsyncComponent({
  loader: () => import('./components/danmu_section.vue'), //弹幕部分
});

let dialog_state = shallowReactive({
  hongbao: false,
  reward: false,
});

function showJiangchi() {
  dialog_state.jiangchi = true;
  GlobalReporter.add({ btn_name: '查看奖池' });
}

function handle_invite() {
  eventEmitter.emit('toast', {
    text: '活动已过期',
  });
  return;
  GlobalReporter.add({ btn_name: '抽奖-邀请预约' });
  showShareGuideHandle('orderShare');
}

function handle_create_team() {
  eventEmitter.emit('toast', {
    text: '活动已过期',
  });
  return 
  GlobalReporter.add({ btn_name: '抽奖-邀请组队' });
  showShareGuideHandle('choujiang_invite');
}

const task_list_status = ref([]);
let yuyue = ref(0);
onMounted(async () => {
  const res = await get_table_data();
  set_table_data(res);
  if (res.code == 1) {
    task_list.value = res.data.task_data;
  }
  set_activity_config(res);
  // 获取任务状态
  let res2 = await get_appoint_data();
  if (res2.code == 1) {
    yuyue.value = res2.data.count;
  }
  eventEmitter.on('show_together', (data) => {
    chou.value = data;
    chou.value.bonus_type = 1;
    dialog_state.reward = true;
  });

  eventEmitter.on('chou', () => {
    handle_chou();
  });

  eventEmitter.on('refresh_taskList_bus', () => {
    refreshTaskList();
  });
});

const video_effect_ref = ref(null);
const chou = ref(null);
let show_id = shallowRef('');
const { isWeChat, isMiniProgram } = useWeChatEnv();
async function handle_chou() {
  eventEmitter.emit('toast', {
    text: '活动已过期',
  });
  return;

  if (channel.channel !== 'wx') {
    eventEmitter.emit('showCommomTipModal', 'copyLink');
    return;
  }

  const res = await post_draw_lottery();
  if (res.code == 1) {
    chou.value = res.data.result;
    if (activity_config.value.item_data[chou.value.item_id].icon_2) {
      handle_play_effect_2();
      show_id.value = chou.value.item_id;
    } else {
      handle_play_effect();
    }
    update_usable_lottery_times(res.data.usable_lottery_times);
    set_share_config();
  } else {
    eventEmitter.emit('toast', {
      text: '抽奖报错',
    });
  }
}

// 大奖设置
function set_share_config() {
  if (
    activity_config.value.item_data[chou.value.item_id].level &&
    activity_config.value.item_data[chou.value.item_id].level < 5 &&
    chou.value.bonus_type == 0
  ) {
    let random = getRandomInt(1);
    let desc = '';
    if (random == 0) {
      desc = `我抽中了<${activity_config.value.item_data[chou.value.item_id].name}>!每抽必中，快来试试手气~`;
    } else if (random == 1) {
      desc = `<${activity_config.value.item_data[chou.value.item_id].name}>已领到,活动真实有效，一起瓜分千万奖池吧~`;
    } else if (random == 2) {
      desc = `瓜分千万奖池，我抽到了<${activity_config.value.item_data[chou.value.item_id].name}>！库存充裕，人人有奖!`;
    } else {
      desc = `超高爆率！我已抽中<${activity_config.value.item_data[chou.value.item_id].name}>!,点击链接，一键速抽！`;
    }
    let icon = activity_config.value.item_data[chou.value.item_id].icon_4;
    let src = '';
    if (icon) {
      src = config[icon].src;
      console.log(icon, '提取的路径');
      if (src) {
        src = `${config[icon].src}.png`;
      } else {
        src = `https://g20.gsf.netease.com/20251016-161150/tx_share_1.png`;
      }
    } else {
      src = `https://g20.gsf.netease.com/20251016-161150/tx_share_1.png`;
    }
    eventEmitter.emit(
      'regsnsShareBus',
      { item_id: chou.value.id },
      {
        title: desc,
        desc: '《天下：万象》预约开启！三端互通，逆天改命！',
        imgUrl: src,
      }
    );
  } else {
    // 同享邀请
  }
}

function handle_play_effect() {
  video_effect_ref.value?.play();
}

const video_effect_ref_2 = ref();
function handle_play_effect_2() {
  // 播放高级道具
  video_effect_ref_2.value?.play();
}

function handle_show_reward() {
  show_id.value = '';
  dialog_state.reward = true;
}

// 当前抽奖次数
const computed_lotter_items = computed(() => {
  if (init_data.act_data) {
    return init_data.act_data.usable_lottery_times;
  } else {
    return 0;
  }
});

// 当前未完成任务
const computed_task = computed(() => {
  if (task_list_status.value.length > 0) {
    if (task_list_status.value[0].status == 0) {
      return 0;
    } else if (task_list_status.value[1].status == 0) {
      return 1;
    } else if (
      task_list_status.value[1].status == 1 &&
      task_list_status.value[0].status == 1
    ) {
      return 2;
    }
  }
  return 0;
});

// 当前同享角色
let bonus_data = ref(null);
watch(together_id, async (newVal) => {
  if (newVal) {
    // 查询消息
    const res = await get_bonus_share_data(newVal);
    if (res.code == 1) {
      bonus_data.value = res.data;
    }
  }
});

// 大奖分享
let dajiang_data = ref(null);
watch(item_id, async (newVal) => {
  if (newVal) {
    // 查询消息
    const res = await get_bonus_share_data(newVal);
    if (res.code == 1) {
      dajiang_data.value = res.data;
    }
  }
});

async function handle_get_bonus() {
  if (login_status.value == false) {
    eventEmitter.emit('login');
  } else {
    const res = await post_share_bonus({ bonus_id: bonus_data.value.bonus_id });
    if (res.code == 0) {
      eventEmitter.emit('toast', {
        text: res.errorMsg,
      });
    } else {
      eventEmitter.emit('toast', {
        text: '领取同享奖励成功',
      });
      eventEmitter.emit('show_reward');
    }
    set_together_id('');
  }
}

// 同享的设置
function handle_share() {
  let random = getRandomInt(1);
  let desc = '';
  let icon = activity_config.value.item_data[chou.value.item_id].icon_4;
  let src = '';
  if (icon) {
    src = config[icon].src;
    if (src) {
      src = `${config[icon].src}.png`;
    } else {
      src = `https://g20.gsf.netease.com/20251016-161150/tx_share_1.png`;
    }
  } else {
    src = `https://g20.gsf.netease.com/20251016-161150/tx_share_1.png`;
  }
  if (random == 0) {
    desc = `【同享邀请】我抽中了<${activity_config.value.item_data[chou.value.item_id].name}>,点击可同享，速领！`;
  } else {
    desc = `【同享邀请】送你<${activity_config.value.item_data[chou.value.item_id].name}>,点击即领取，手慢无!`;
  }
  eventEmitter.emit(
    'regsnsShareBus',
    { together_id: chou.value.id },
    {
      title: desc,
      desc: '《天下：万象》预约开启！三端互通，逆天改命！',
      imgUrl: src,
    }
  );
  if (!(isMiniProgram.value || isWeChat.value)) {
    eventEmitter.emit('showCommomTipModal', 'togetherCopyLink');
  } else {
    dialog_state.reward = false;
    // dialog_state.first = true;
    showShareGuideHandle('together');
  }
}

function beforeCheck() {
  if (!(isMiniProgram.value || isWeChat.value)) {
    eventEmitter.emit('showCommomTipModal', 'copyLink');
    return false;
  }
  if (!login_status.value) {
    eventEmitter.emit('login');
    return false;
  }
  if (!!error_codemsg.value) {
    eventEmitter.emit('toast', {
      text: error_codemsg.value,
    });
    return false;
  }
  return true;
}

// 奖池tips相关
const is_tips = shallowRef(false);
const tips_id = shallowRef(null);
const tips_info = ref(null);
const computed_tips = computed(() => {
  return activity_config.value.item_data[tips_id.value];
});

function handle_show_tips(id) {
  is_tips.value = true;
  tips_id.value = id;
  tips_info.value = encodeText(computed_tips.value.desc);
}

function methodsStyle(style) {
  let obj = {};
  if (style.color) {
    obj.color = style.color;
  }
  return obj;
}

function showGroupGuideModal() {
  eventEmitter.emit('showGroupGuideModal');
}

const show_jiangchi = computed(() => {
  let res = [];
  activity_config.value.awrad_data.map((item) => {
    if (activity_config.value.item_data[item].icon_3) {
      res.push(item);
    }
  });
  return res;
});

const swiperRef = ref();
const handlePrev = () => {
  swiperRef.value?.prev();
};
const handleNext = () => {
  swiperRef.value?.next();
};

// 是否是高级道具
const is_high = computed(() => {
  if (
    chou.value.bonus_type == 0 &&
    activity_config.value.item_data[chou.value.item_id].icon_3
  ) {
    return true;
  } else {
    return false;
  }
});

function handle_share_reward() {
  dialog_state.reward = false;
  showShareGuideHandle('reward_high');
}

async function showShareGuideHandle(type) {
  console.log('task_list_status.value', task_list_status.value);

  const ispass = beforeCheck();
  if (!ispass) return;
  if (['orderShare', 'first'].includes(type)) {
    eventEmitter.emit('regsnsShareBus', {}, choujiangShareConfig());
  }
  if (type === 'invite') {
    eventEmitter.emit(
      'regsnsShareBus',
      { invite_id: init_data.id },
      inviteShareConfig()
    );
  }
  if (type === 'choujiang_invite') {
    eventEmitter.emit(
      'regsnsShareBus',
      { invite_id: init_data.id },
      inviteShareConfig()
    );
  }
  if (task_list_status.value[0]?.status == 0) {
    const res = await get_do_share();
    if (res.code == 1) {
      eventEmitter.emit({
        toast: '点击右上角分享好友',
      });
      setTimeout(() => {
        eventEmitter.emit('refresh_taskList_bus');
        eventEmitter.emit('refresh_init_bus');
      }, 500);
    }
  }
  eventEmitter.emit('showShareGuideModal', type);
}

/**
 * 获取任务状态
 */
async function refreshTaskList() {
  const res = await get_get_task_list();
  if (res.code == 1) {
    task_list_status.value = res.data.task_list;
  }
}

async function handle_yuyue() {
  eventEmitter.emit('toast',{
        text: '活动已过期',
      });
  return 
  if (login_status.value === false) {
    eventEmitter.emit('login');
  } else {
    if (share_id.value) {
      if (share_id.value === init_data.id) {
        if (init_data.act_data.is_appointed == false) {
          const res = await appoint();
          if (res.code == 1) {
            await initAction();
            eventEmitter.emit('refresh_init_bus');
            eventEmitter.emit('showHongbaoModal');
          } else {
            eventEmitter.emit('toast', {
              text: res.errorMsg,
            });
          }
        }
      } else {
        if (init_data.act_data.is_appointed == false) {
          const res = await appoint({ share_id: share_id.value });
          if (res.code == 1) {
            eventEmitter.emit('refresh_init_bus');
            eventEmitter.emit('showHongbaoModal');
          } else {
            eventEmitter.emit('toast', {
              text: res.errorMsg,
            });
          }
        }
      }
    } else {
      if (init_data.act_data.is_appointed == false) {
        const res = await appoint();
        if (res.code == 1) {
          eventEmitter.emit('refresh_init_bus');
          eventEmitter.emit('showHongbaoModal');
        } else {
          eventEmitter.emit('toast', {
            text: res.errorMsg,
          });
        }
      }
    }
  }
}

// 全屏视频
const videoRef = ref(null);
const is_video = ref(false);
function handle_play_video() {
  is_video.value = true;
  videoRef.value?.play();
}

function onVideoEnded() {
  is_video.value = false;
}

function handle_tips() {
  eventEmitter.emit('toast', {
    text: '抽奖次数不足！',
  });
}

watch(login_status, async (v) => {
  if (v) {
    console.log('已登录');
    if (init_data.can_receive_reward) {
      let res = await get_redpacket_info();
      if (res.code == 1) {
        if (res.data.amount > 0) {
          eventEmitter.emit('showHongbaoModal', { data: res.data });
        }
      }
    }
  }
});
</script>
<style lang="scss" scoped>
.main {
  position: relative;
  @include bg('bg_duan2');
  width: 100vw;

  .group-btn {
    position: fixed;
    right: 0;
    top: 1190px;
    z-index: 10;
  }
}

.main-fenxiang {
  color: #fff;
  padding: 50px;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
}

.main-fenxiang-container {
  width: 480px;
  height: 130px;
  position: absolute;
  bottom: 0;
}

.invite-share {
  position: absolute;
  top: 10px;
  right: 30px;
  @include bg('jiantou_5');
  display: flex;
  align-items: flex-end;
  justify-content: center;
  box-sizing: border-box;
  padding-right: 5px;
  padding-bottom: 50px;

  span {
    font-size: 26px;
    color: #fff;
  }
}

.main-fenxiang-text {
  // position: absolute;
  // bottom: 10px;
}

.main-show {
  width: 100%;
  position: relative;
  height: 500px;
}

.qcjj {
  margin-right: 30px;
  position: relative;
  top: -150px;
}

.yuyue-text {
  color: #aabfca;
  font-size: 27px;
  font-family: 'KaiTi', '楷体', serif;
  margin-top: -130px;
}

.yuyue-text p {
  font-size: 45px;
  --bg-size: 400%;
  /* 自定义CSS变量：背景尺寸 */
  --color-one: #9fd3eb;
  /* 橙红色 */
  --color-two: #ffffff;
  /* 亮黄色 */
  /* 关键：用渐变背景填充文字 */
  // background: linear-gradient(180deg, var(--color-one), var(--color-two)) 0 0 / 100% var(--bg-size);
  background: linear-gradient(
    180deg,
    #ffffff 0%,
    #ffffff 10%,
    #9fd3eb 70%,
    #9fd3eb 100%
  );
  color: transparent;
  /* 文字本身透明 */
  background-clip: text;
  /* 背景仅在文字区域内显示 */
  animation: move-bg 8s linear infinite;
}

@keyframes move-bg {
  to {
    background-position: 0 400%;
  }
}

.pro p {
  font-size: 25px;
  color: #7c8b9c;
}

.main-reward {
  // width: 100%;
  // height: 560px;
  // margin-top: 50px;
  // position: relative;
}

.main-reward span {
  font-size: 18px;
  color: #596a7c;
}

.huangjin {
  position: absolute;
  left: 70px;
  bottom: 50px;
}

.xianjin {
  position: absolute;
  left: 120px;
  bottom: 120px;
}

.lihe {
  position: absolute;
  right: 75px;
  bottom: 130px;
}

.look_reward {
  font-size: 20px !important;
  color: #e8e8e8 !important;
  margin-left: 5px;
}

.main-choujiang {
  width: 100%;
}

.main-chou {
  color: #264971;
  font-size: 20px;
}

.task-title {
  font-size: 47px;
  --bg-size: 400%;
  /* 自定义CSS变量：背景尺寸 */
  --color-one: #9fd3eb;
  /* 橙红色 */
  --color-two: #ffffff;
  /* 亮黄色 */
  /* 关键：用渐变背景填充文字 */
  background: linear-gradient(
    180deg,
    #ffffff 0%,
    #ffffff 10%,
    #9fd3eb 70%,
    #9fd3eb 100%
  );
  color: transparent;
  /* 文字本身透明 */
  background-clip: text;
  /* 背景仅在文字区域内显示 */
}

.task {
  width: 100%;
  height: 350px;
  margin-top: 50px;
}

.task-header span {
  font-size: 47px;
  font-family: 'KaiTi', '楷体', serif;
}

.task-list {
  color: #65778b;
  font-size: 19px;
  margin-top: 20px;
}

.share-link {
  color: #ebbd61;
  text-decoration: underline;
}

.main-fenxiang h1 {
  font-size: 40px;
}

.main-reward-item {
  position: relative;
}

.main-reward-item-count {
  position: absolute;
  top: -50px;
  right: -50px;
  font-size: 20px;
  padding-top: 45px;
  padding-left: 30px;
}

.main-fenxiang-container-2 {
  width: 480px;
  height: 480px;
}

.main-jiangchi {
  @include bg('xiadi');
}

.dialog-btn {
  font-size: 29px;
}

.main-reward-together span {
  color: white;
  font-size: 23px;
}

.main-reward-together p {
  color: #202631;
  font-size: 23px;
}

.yuyue-num {
  font-size: 20px;
  color: #ffedae;
}

.countdown {
  font-size: 20px;
  color: #ffffff;
}

.tongxiang-title {
  position: relative;
  top: 0px;
}

.tongxiang-container {
  width: 300px;
  height: 400px;
}

.tips-container {
  @include bg('tips');
}

.tips-header {
  width: 100%;
  height: 110px;
  font-size: 28px;
  color: #9c9486;
}

.tips-content {
  height: 430px;
  width: 98%;
  // border: #e8e8e8 1px solid;
  font-size: 24px;
  color: #d8d8d8;
  padding: 10px 20px;
}

.side {
  @include bg('cebian');
  position: fixed;
  left: 0;
  top: 50%;
  z-index: 99;
  font-size: 24px;
  color: #4c5e72;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;

  a {
    text-decoration: none;
    color: #4c5e72;
    position: relative;
    left: -8px;
  }
}

.side_xian {
  position: absolute;
  right: 0;
  top: -40px;
}

.chakan {
  margin-top: -80px;
  margin-bottom: 50px;
}

.wuqiTips-item {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  // margin: 10px 0px;
}

.qipao {
  position: absolute;
  top: -30px;
  left: 300px;
  box-sizing: border-box;
}

.jiangchi-tips {
  position: absolute;
  bottom: 0px;
}

.reward-swiper-left {
  position: absolute;
  left: -25px;
  top: 200px;
  width: 100px;
  height: 100px;
}

.reward-swiper-right {
  position: absolute;
  right: -25px;
  top: 200px;
  width: 100px;
  height: 100px;
}

.swiper-item-name {
  position: absolute;
  color: #243a5b;
  top: -80px;
}

.swiper-container {
  position: relative;
  top: -30px;
}

.all-reward {
  font-size: 20px;
  color: #3d5778;
  margin-top: -30px;
  position: relative;
  left: 0px;
}

.xian-margin {
  margin: 0 -90px;
}

.shaoxia-jihe {
  font-size: 20px;
  color: #7f93a9;
}

.tips-name {
  position: relative;
  top: -20px;
}

.dialog-close {
  position: absolute;
  top: 1200px;
}

.hight-reward-name {
  position: relative;
  top: -120px;
}

.play-video {
  position: absolute;
  left: 430px;
  top: 30px;
}
</style>
